import { Stack } from '@mantine/core'
import { forwardRef, memo, useImperativeHandle, useRef } from 'react'

import type { CMFormSection } from '@/screens/ContentModuleFormScreen/ContentModuleFormScreen'
import { FAQSection, type FAQSectionRef } from '@/screens/ContentModuleFormScreen/FAQSection'

export interface OptionalSettingsSectionRef {
  saveFAQs: () => Promise<void>
}

export const OptionalSettingsSection = memo(
  forwardRef<OptionalSettingsSectionRef, CMFormSection>((props, ref) => {
    const faqSectionRef = useRef<FAQSectionRef>(null)

    useImperativeHandle(
      ref,
      () => ({
        saveFAQs: async () => {
          await faqSectionRef.current?.saveUnsavedFAQs()
        },
      }),
      [],
    )
    return (
      <Stack gap="xxxl">
        <FAQSection {...props} type="cm" ref={faqSectionRef} />
      </Stack>
    )
  }),
)

OptionalSettingsSection.displayName = 'OptionalSettingsSection'
